export type AutoStartDefaultInput = {
    readonly urgent: boolean;
    readonly autoStartOverride: boolean | null;
    readonly autoStartDefault: boolean;
};

export function resolveAutoStartDefault({
    urgent,
    autoStartOverride,
    autoStartDefault,
}: AutoStartDefaultInput): boolean {
    return autoStartOverride ?? (urgent || autoStartDefault);
}
